"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scrollToFullyVisibleY = scrollToFullyVisibleY;
var _getScrollParent = _interopRequireWildcard(require("./getScrollParent"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function isScrollableY(element) {
  var hasScrollableContent = element.scrollHeight > element.clientHeight;
  var _window$getComputedSt = window.getComputedStyle(element),
    overflowY = _window$getComputedSt.overflowY;
  return hasScrollableContent && (0, _getScrollParent.isScrolling)(overflowY);
}
function scrollToFullyVisibleY(_ref) {
  var container = _ref.container,
    element = _ref.element;
  var scrollParent = (0, _getScrollParent["default"])({
    withCondition: isScrollableY,
    element: element,
    container: container
  });
  var elementRelativeTop = element.offsetTop - scrollParent.offsetTop;
  var elementRelativeBottom = elementRelativeTop + element.clientHeight;
  var scrollParentViewBottom = scrollParent.scrollTop + scrollParent.clientHeight;
  if (scrollParent.scrollTop > elementRelativeTop) {
    scrollParent.scroll({
      top: elementRelativeTop,
      behavior: 'auto'
    });
  }
  if (scrollParentViewBottom < elementRelativeBottom) {
    scrollParent.scroll({
      top: elementRelativeBottom - scrollParent.clientHeight,
      behavior: 'auto'
    });
  }
}